import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { ViewStyle } from 'react-native';

const ChevronDown = ({ style }: { style?: ViewStyle }) => {
  return (
    <Svg width="20" height="21" viewBox="0 0 20 21" fill="none" style={style}>
      <Path
        d="M6.175 7.49219L10 11.3172L13.825 7.49219L15 8.67552L10 13.6755L5 8.67552L6.175 7.49219Z"
        fill="#6C777C"
      />
    </Svg>
  );
};

export default ChevronDown;
